import React, { useState } from 'react';
import CheckingYear from "./screens/CheckingYear";
import UnderAge from "./screens/UnderAge";
import { getCookie } from "./utils/cookie";
import Navigation from "./Navigation";

const App = () => {
  const [ yearsCookie ] = useState(getCookie('years'))

  return (
    <>
      {!yearsCookie ? <CheckingYear/> : yearsCookie < 18 ? <UnderAge/> : <Navigation />}
    </>
  );
}

export default App;
